import {Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  public currentName = signal<string|undefined>(undefined);
  public currentId = signal<string|undefined>(undefined);
}
